module.exports = __webpack_public_path__ + "static/media/evinfrastructure_1.8d096012.jpeg";